export const database = {
    "Marvel" : [
        {
            name : "The Incredible Hulk",
            releaseDate : "2008",
            ratingIMDb : "6.7/10",
            director : "Louis Leterrier",
            poster : "https://wallpapercave.com/wp/2Cf6ajq.jpg"
        },
        {
            name : "Iron Man",
            releaseDate : "2008",
            ratingIMDb : "7.9/10",
            director : "Jon Faverou",
            poster : "https://wallpaperaccess.com/full/1653412.jpg"
        },
        {
            name : "Iron Man 2",
            releaseDate : "2010",
            ratingIMDb : "7/10",
            director : "Louis Leterrier",
            poster : "https://images8.alphacoders.com/662/662512.jpg"
        },
        {
            name : "Iron Man 3",
            releaseDate : "2013",
            ratingIMDb : "7.2/10",
            director : "Shane Black",
            poster : "https://images8.alphacoders.com/378/thumb-1920-378546.jpg"
        },
        {
            name : "Thor",
            releaseDate : "2011",
            ratingIMDb : "7/10",
            director : "Kenneth Branagh",
            poster : "https://wallpaperaccess.com/full/645142.jpg"
        },
        {
            name : "Thor The Dark World",
            releaseDate : "2013",
            ratingIMDb : "6.9/10",
            director : "Alan Taylor",
            poster : "https://wallpapercave.com/wp/wp3079593.jpg"
        },
        {
            name : "Thor: Ragnarok",
            releaseDate : "2017",
            ratingIMDb : "7.9/10",
            director : "Taika Waititi",
            poster : "https://7wallpapers.net/wp-content/uploads/7_Thor-Ragnarok.jpg"
        },
        {
            name : "The Avengers",
            releaseDate : "2012",
            ratingIMDb : "8/10",
            director : "Joss Whedon",
            poster : "https://wallpapercave.com/wp/6lvp4zT.jpg"
        },
        {
            name : "Avengers:Age Of Ultron",
            releaseDate : "2015",
            ratingIMDb : "7.3/10",
            director : "Joss Whedon",
            poster : "https://wallpapercave.com/wp/wp1818455.jpg"
        },
        {
            name : "Avengers: Infinity War",
            releaseDate : "2018",
            ratingIMDb : "8.4/10",
            director : "Joe Russo, Anthony Russo",
            poster : "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/5298bac0-b8bf-4c80-af67-725c1272dbb0/dbqyhh7-1aaad27e-1e5c-4fa1-96c5-7a888a6dbefe.jpg/v1/fill/w_1192,h_670,q_70,strp/avengers__infinity_war_wallpaper_by_thekingblader995_dbqyhh7-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOiIsImlzcyI6InVybjphcHA6Iiwib2JqIjpbW3siaGVpZ2h0IjoiPD0xMDgwIiwicGF0aCI6IlwvZlwvNTI5OGJhYzAtYjhiZi00YzgwLWFmNjctNzI1YzEyNzJkYmIwXC9kYnF5aGg3LTFhYWFkMjdlLTFlNWMtNGZhMS05NmM1LTdhODg4YTZkYmVmZS5qcGciLCJ3aWR0aCI6Ijw9MTkyMCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.xYiCwtw4AoZnU7TxQHDX7Lae60bM59yM-1l6JjmaPF0"
        },
    ],
    "DC Comics" : [
        {
            name : "Batman Begins",
            releaseDate : "2005",
            ratingIMDb : "8.2/10",
            director : "Christopher Nolan",
            poster : "https://wallpapercave.com/wp/wp2722476.jpg"
        },
        {
            name : "The Dark Knight",
            releaseDate : "2008",
            ratingIMDb : "9/10",
            director : "Christopher Nolan",
            poster : "https://cdn.wallpapersafari.com/52/41/kl4GTX.jpg"
        },
        {
            name : "The Dark Knight Rises",
            releaseDate : "2012",
            ratingIMDb : "8.4/10",
            director : "Christopher Nolan",
            poster : "https://i.pinimg.com/originals/ac/7b/13/ac7b13431c8acd1031333351669f09d0.jpg"
        }
    ],
    "Mind-Fuck Movies" : [
        {
            name : "Inception",
            releaseDate : "2010",
            ratingIMDb : "8.8/10",
            director : "Christopher Nolan",
            poster : "https://wallpaperaccess.com/full/1264685.jpg"
        },
        {
            name : "Shawshank Redemption",
            releaseDate : "1994",
            ratingIMDb : "9.3/10",
            director : "Frank Darabont",
            poster : "https://wallpapercave.com/wp/wp2014276.jpg"
        },
        {
            name : "Edge of Tomorrow",
            releaseDate : "2014",
            ratingIMDb : "7.9/10",
            director : "Doug Liman",
            poster : "https://cdn.hipwallpaper.com/i/78/95/VGgit2.jpg"
        },
        {
            name : "Interstellar",
            releaseDate : "2014",
            ratingIMDb : "8.6/10",
            director : "Christopher Nolan",
            poster : "https://desktopwalls.net/wp-content/uploads/2015/03/Interstellar%20Movie%20Satellite%20Desktop%20Wallpaper.jpg"
        },
    ]
}